/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<cdf20aef39bb9c8f6cd9d21b845ea367>>
 *
 * Generated by LanguageCLDRGenScript
 *
 * 
 */
'use strict';

var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType39 = {
  getVariation: function getVariation(n) {
    return IntlVariations.NUMBER_OTHER;
  }
};
module.exports = IntlCLDRNumberType39;